// extracted by mini-css-extract-plugin
export var checkIcon = "_7-2";
export var heading = "_7-1";
export var panel = "_7-0";